import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, firstValueFrom, map, of } from 'rxjs';
import { DealerHelperService } from './dealer-helper.service';
import { IDealerByLocation, IResponseModel } from '@core/interface';
import { API, environment } from '@core/envs';

@Injectable({
  providedIn: 'root'
})
export class DealerListService extends DealerHelperService {
  private readonly http = inject(HttpClient);

  async getList(
    originUser: { lat: number; lng: number },
    searchLocation: { lat: number; lng: number },
    pickup: boolean,
    modelGroup: string | null
  ) {
    const api = environment.getRoute(API.dealer);
    const url = `${api}/dealers/coordinates`;

    const body = {
      currentLat: originUser.lat,
      currentLng: originUser.lng,
      lat: searchLocation.lat,
      lng: searchLocation.lng,
      modelGroup: modelGroup ?? '',
      pickUp: pickup
    };

    this.list.set({ dealers: [], loading: true, error: false });

    await firstValueFrom(
      this.http.post<IResponseModel<IDealerByLocation[]>>(url, body).pipe(
        map((response) => {

          const dealerList = response?.response || [];

          const formattedDealerList = dealerList.map(dealer => {
            // Calcular a distância em quilômetros com uma casa decimal
            if (dealer.distance) {
              dealer.distance = Number((dealer.distance / 1000).toFixed(1));
            }

            // Verificar tipo de veículo e marcar flags de especialista
            this.setDealerSpecialistFlags(dealer);

            // Formatar horários de serviço e retornar o dealer
            return this.formatDealerServiceHours(dealer);
          });

          this.list.set({ dealers: formattedDealerList, loading: false, error: false });

          return formattedDealerList;
        }),
        catchError(() => {
          this.list.set({ dealers: [], loading: false, error: true });
          return of([]);
        })
      )
    );
  }
}
